import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-clients',
    templateUrl: './clients.component.html',
    styleUrls: ['./clients.component.scss'],
    standalone: false
})
export class ClientsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
